import { handleActions } from 'redux-actions'

import {
  GET_SUBSCRIPTION_START,
  GET_SUBSCRIPTION_SUCCESS,
  GET_SUBSCRIPTION_ERROR,
  GET_SUBSCRIPTION_FINALLY,
  SET_SUBSCRIPTIONS_START,
  SET_SUBSCRIPTIONS_SUCCESS,
  SET_SUBSCRIPTIONS_ERROR,
  CHANGE_SUBSCRIPTION_START,
  CHANGE_SUBSCRIPTION_SUCCESS,
  CHANGE_SUBSCRIPTION_ERROR,
  VALIDATE_SUBSCRIPTION_START,
  VALIDATE_SUBSCRIPTION_SUCCESS,
  VALIDATE_SUBSCRIPTION_ERROR,
  VALIDATE_SUBSCRIPTION_FINALLY,
  CANCEL_SUBSCRIPTION_START,
  CANCEL_SUBSCRIPTION_SUCCESS,
  CANCEL_SUBSCRIPTION_ERROR,
  CANCEL_SUBSCRIPTION_FINALLY,
  SET_COMPENSATION_START,
  SET_COMPENSATION_ERROR,
  SET_COMPENSATION_FINALLY,
  CLEAR_SUBSCRIPTION_ERROR,
  UPDATE_SUBSCRIBER
} from '../../redux/actions'

const initialState = {
  data: {},
  error: null,
  isLoading: true,
  urlToPaySubscription: '',
  transaction: {},
  isLoadingCancel: false,
  errorCancel: null,
  dataCancel: null,
  isFreePlan: true,
  subscriptionsPlanIds: [],
  oneTimePurchases: [],
  planIdToHasAds: {},
  subscriber: {},
  compensationError: null,
  isLoadingCompensation: false
}

export default handleActions({
  [GET_SUBSCRIPTION_START]: state => ({
    ...state,
    isLoading: true,
    error: false
  }),
  [GET_SUBSCRIPTION_SUCCESS]: (state, action) => ({
    ...state,
    data: action.payload.subscription,
    isFreePlan: action.payload.isFreePlan,
    subscriptionsPlanIds: action.payload.subscriptionsPlanIds,
    oneTimePurchases: action.payload.oneTimePurchases || [],
    planIdToHasAds: action.payload.planIdToHasAds || {},
    subscriber: action.payload.subscriber
  }),
  [GET_SUBSCRIPTION_ERROR]: (state, action) => ({
    ...state,
    error: action.payload
  }),
  [GET_SUBSCRIPTION_FINALLY]: state => ({
    ...state,
    isLoading: false
  }),
  [SET_SUBSCRIPTIONS_START]: state => ({
    ...state,
    isLoading: true,
    error: false
  }),
  [SET_SUBSCRIPTIONS_SUCCESS]: (state, action) => ({
    ...state,
    urlToPaySubscription: action.payload
  }),
  [SET_SUBSCRIPTIONS_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false
  }),
  [CHANGE_SUBSCRIPTION_START]: state => ({
    ...state,
    isLoading: true,
    error: false
  }),
  [CHANGE_SUBSCRIPTION_SUCCESS]: (state, action) => ({
    ...state,
    urlToPaySubscription: action.payload
  }),
  [CHANGE_SUBSCRIPTION_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false
  }),
  [VALIDATE_SUBSCRIPTION_START]: state => ({
    ...state,
    isLoading: true,
    error: false
  }),
  [VALIDATE_SUBSCRIPTION_SUCCESS]: (state, action) => ({
    ...state,
    transaction: action.payload
  }),
  [VALIDATE_SUBSCRIPTION_ERROR]: (state, action) => ({
    ...state,
    error: action.payload
  }),
  [VALIDATE_SUBSCRIPTION_FINALLY]: state => ({
    ...state,
    isLoading: false
  }),
  [CANCEL_SUBSCRIPTION_START]: state => ({
    ...state,
    isLoadingCancel: true,
    error: false
  }),
  [CANCEL_SUBSCRIPTION_SUCCESS]: (state, action) => ({
    ...state,
    dataCancel: action.payload,
    isLoadingCancel: false
  }),
  [CANCEL_SUBSCRIPTION_ERROR]: (state, action) => ({
    ...state,
    errorCancel: action.payload
  }),
  [CANCEL_SUBSCRIPTION_FINALLY]: state => ({
    ...state
  }),
  [SET_COMPENSATION_START]: state => ({
    ...state,
    compensationError: null,
    isLoadingCompensation: true
  }),
  [SET_COMPENSATION_ERROR]: (state, action) => ({
    ...state,
    compensationError: action.payload
  }),
  [SET_COMPENSATION_FINALLY]: state => ({
    ...state,
    isLoadingCompensation: false
  }),
  [CLEAR_SUBSCRIPTION_ERROR]: state => ({
    ...state,
    error: null
  }),

  [UPDATE_SUBSCRIBER]: (state, action) => ({
    ...state,
    subscriber: action.payload.email ?
      { ...state.subscriber, hasCouponPreAssigned: true, email: action.payload.email }
      : { ...state.subscriber, hasCouponPreAssigned: true, contact_email: action.payload.contact_email }
  }),
}, initialState)